<template>
    <div class="explain">
        <div style="font-size:20px;margin: 0px 30px 0px 30px;">
            <p>1.《湖南省科技攻关类项目技术需求征集表》由各相关业务处室联合企业、高校、科研院所、省直部门、行业主管部门和市州、园区科技管理部门填报，按照“一项需求一张表”的要求，由处室主要负责人审核把关后上传“科技云”平台共享。</p>
            <p>2.需求征集应聚焦国家重大战略任务，对接国家科技创新2030重大项目与重大工程，围绕“4×4”现代化产业体系中的“卡点”“堵点”、35个领域“卡脖子”清单，围绕我省优势产业集群建设和产业发展“万千百”工程中需要解决的“卡脖子”技术、“杀手锏”技术、“反遏制”技术、颠覆性技术，以及替代进口的关键核心产品，注重培育现代化产业体系新增长点，为围绕创新链全链条设计科技攻关项目做好需求挖掘基础工作。</p>
            <p>3.形成常态化需求征集机制，按行业领域常态化开展供需对接活动，推动科技供需多途径、精准化匹配。需求征集后，相关处室在科技攻关类项目凝练过程中应加强需求运用，与需求征集单位协同联动，优化设计研发任务，为凝练形成十大技术攻关、重大技术攻关（含揭榜挂帅）、重点研发计划等攻关类计划项目提供重要的参考依据及需求来源。</p>
            <p>4.安全应急领域包括公共安全与应急及信息、人工智能、空天海洋、种业、生物技术等安全。</p>
            <p>5.攻关技术成熟度评价等级标准设置如下。</p>
        </div>
        <div >
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                :height="screenHeight"
	            :header-cell-style="{
		            background: '#E1EEFB',
		            color: '#000000',
		            fontSize: '18px',
		            textAlign: 'center'}"
	            :cell-style="{
		            'text-align': 'center',
		            padding: '0.5rem 0',
		            fontSize: '18px'}">
                <el-table-column prop="date" label="等级"></el-table-column>
                <el-table-column prop="name" label="技术成熟度特征描述"></el-table-column>
                <el-table-column prop="address" label="主要成果形式"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        tableData: [{
          date: '第1级',
          name: '观察到基本原理并形成正式报告',
          address: '报告'
        }, {
          date: '第2级',
          name: '形成了技术概念或开发方案',
          address: '方案'
        }, {
          date: '第3级',
          name: '关健功能分析和实验结论成立',
          address: '验证结论'
        }, {
          date: '第4级',
          name: '研究室环境中的部件伤真验证',
          address: '仿真结论'
        }, {
          date: '第5级',
          name: '相关环境中的部件仿真验证',
          address: '部件'
        }, {
          date: '第6级',
          name: '相关环境中的系统样机演示',
          address: '模型样机'
        }, {
          date: '第7级',
          name: '在实际环境中的系统样机试验结论成立',
          address: '样机'
        }, {
          date: '第8级',
          name: '实际系统完成并通过实际验证',
          address: '中试产品'
        }, {
          date: '第9级',
          name: '实际通过任务运行的成功考验，可销售',
          address: '产品、标准、专利'
        }]
      }
    }
  }
</script>

</script>
<style lang="scss" scoped>
// ::v-deep .el-dialog__header {
// 	background-color:#F5F5F5;
// 	color: #333333;
// }


.list {
	.topsTable {
		margin-bottom: 20px;
	}
}
</style>